const NameLengthType = Object.freeze({
  SHORT: 'short',
  MEDIUM: 'medium',
  LONG: 'long',
} as const);

export type NameLengthType = (typeof NameLengthType)[keyof typeof NameLengthType];

export const allNameLengthTypes: [NameLengthType, ...NameLengthType[]] = Object.values(NameLengthType) as [
  NameLengthType,
  ...NameLengthType[],
];

export default NameLengthType;
